import ApplicationController from './application_controller'

export default class extends ApplicationController {
  select() {
    const posX = this.element.dataset.posX
    const posY = this.element.dataset.posY
    const row = document.querySelector(
      `[data-target~="proposed-placement.sensorRow"][data-pos-x="${posX}"][data-pos-y="${posY}"]`
    )
    if (!row) return

    document.querySelectorAll('[data-target~="proposed-placement.sensorRow"]').forEach(r => r.classList.remove('selected'))
    row.classList.add('selected')

    document.querySelectorAll('.proposed-sensor-marker.highlighted, .point.highlighted').forEach(m => m.classList.remove('highlighted'))
    this.element.classList.add('highlighted')

    row.scrollIntoView({ block: 'nearest' })
  }
}
